
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands",
      function () {
        return require("private-next-pages/severalbrands/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands"])
      });
    }
  